import React from "react";

interface CheckoutStepIntroProps {
  title: string;
  description: string;
}

/** Tight heading group shared across checkout wizard steps. */
export const CheckoutStepIntro = React.forwardRef<HTMLHeadingElement, CheckoutStepIntroProps>(
  ({ title, description }, ref) => (
    <div className="space-y-1.5">
      <h2 
        ref={ref} 
        tabIndex={-1} 
        className="text-2xl font-semibold text-foreground text-balance outline-none"
      >
        {title}
      </h2>
      <p className="text-sm leading-relaxed text-text-secondary">{description}</p>
    </div>
  )
);

CheckoutStepIntro.displayName = "CheckoutStepIntro";
